'use client';

import { Box, HStack, VStack } from '@terra/ui-styled-system';
import { Text } from '../../../components/styled/text';
import {
  CircleIcon,
  CheckmarkCircle01Icon,
  CircleSlash2Icon,
  Loading03Icon,
  StopIcon,
} from '@terra/ui-icons';

export type TodoItem = {
  id: string;
  content: string;
  status: 'pending' | 'completed' | 'in_progress' | 'cancelled';
};
export type TracePlanProps = {
  plan?: TodoItem[];
  status?: 'running' | 'completed' | 'error' | 'aborted';
};
export function TracePlanItems({ plan, status }: TracePlanProps) {
  if (!plan || !plan?.length) {
    return null;
  }

  return (
    <VStack gap={0} alignItems="stretch">
      {plan.map((todo) => {
        const isDone = todo.status === 'completed';
        const isCancelled = todo.status === 'cancelled';
        const inProgress = todo.status === 'in_progress';

        return (
          <HStack
            key={todo.id}
            gap={1.5}
            py={1}
            alignItems="center"
            borderBottomWidth="1px"
            borderBottomColor="border.subtle"
            _last={{ borderBottomWidth: 0 }}
          >
            <Box
              display="flex"
              alignItems="center"
              flexShrink={0}
              color={isDone ? 'green.9' : isCancelled ? 'fg.muted' : 'fg.muted'}
            >
              {isDone ? (
                <CheckmarkCircle01Icon size={12} strokeWidth={1.6} />
              ) : isCancelled ? (
                <CircleSlash2Icon size={12} strokeWidth={1.6} />
              ) : inProgress ? (
                status === 'running' ? (
                  <Box animation="spin 1s linear infinite" display="flex">
                    <Loading03Icon size={12} strokeWidth={1.6} />
                  </Box>
                ) : status === 'aborted' ? (
                  <StopIcon size={12} strokeWidth={1.6} />
                ) : (
                  <CircleSlash2Icon size={12} strokeWidth={1.6} />
                )
              ) : (
                <CircleIcon size={12} strokeWidth={1.6} />
              )}
            </Box>
            <Text
              fontSize="xs"
              color={isDone ? 'fg.default' : 'fg.muted'}
              fontWeight={inProgress ? 'medium' : 'normal'}
            >
              {todo.content}
            </Text>
          </HStack>
        );
      })}
    </VStack>
  );
}

export function TracePlan(props: TracePlanProps) {
  return <TracePlanItems {...props} />;
}
